import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';
import { AssistedSalesActionType } from '~shared/modules/application-event/constants';

export class GaTrackingAssistedSalesEvent implements GATrackingEvent {
  constructor(
    private event: string,
    private category: string,
    private action?: AssistedSalesActionType,
    private label?: string,
    private employeeId?: string,
    private sharedPaymentLinkId?: string
  ) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.Authorization;
  }

  getPayload(): GATrackingEventPayload {
    const payload: GATrackingEventPayload = {
      event: this.event,
      category: this.category,
      label: this.label,
      gtmCustom: {
        action: this.action,
        category: this.category,
      },
    };

    if (this.employeeId && this.sharedPaymentLinkId) {
      payload.gtmCustom.dimension59 = this.employeeId;
      payload.gtmCustom.dimension60 = this.sharedPaymentLinkId;
    }

    return payload;
  }
}
